import React from "react";
import { Box, Container, Typography, Paper, Grid, Chip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTheme } from "../../../context/ThemeContext";
import { valuePoints } from "../data";

const ValueProposition = () => {
  const { theme } = useTheme();

  return (
    <Box sx={{ bgcolor: "#f8f9fa", py: { xs: 8, md: 10 } }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Chip label="Our Promise" sx={{ bgcolor: theme.lightBg, color: theme.primary, fontWeight: 600, mb: 2 }} />
            <Typography variant="h3" fontWeight={700} sx={{ mb: 3, color: "#1a1a2e" }}>
              Transparent, Secure & Hassle-Free Rentals
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.8 }}>
              At OTS, we believe that renting a property should be simple and stress-free. Our platform brings together property owners and tenants in a secure digital environment, eliminating middlemen and reducing costs for everyone.
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {valuePoints.map((item, index) => (
                <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <CheckCircleIcon sx={{ color: theme.primary, fontSize: 22 }} />
                  <Typography variant="body1">{item}</Typography>
                </Box>
              ))}
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 4, borderRadius: 3, background: `linear-gradient(135deg, ${theme.primary}10 0%, ${theme.secondary}10 100%)` }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 3, textAlign: "center" }}>
                Cost Comparison
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                <Paper sx={{ p: 3, borderRadius: 2, bgcolor: "white" }}>
                  <Typography variant="overline" color="text.secondary">Traditional Method</Typography>
                  <Typography variant="h6" fontWeight={600} sx={{ color: "#d32f2f" }}>
                    1 Month Rent as Commission
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Both owner and tenant pay broker fees
                  </Typography>
                </Paper>
                <Box sx={{ textAlign: "center" }}>
                  <Chip label="VS" sx={{ bgcolor: "#1a1a2e", color: "white", fontWeight: 700 }} />
                </Box>
                <Paper sx={{ p: 3, borderRadius: 2, bgcolor: "white", border: `2px solid ${theme.primary}` }}>
                  <Typography variant="overline" color="text.secondary">With OTS</Typography>
                  <Typography variant="h6" fontWeight={600} sx={{ color: "#2e7d32" }}>
                    500Rs/Property for Owners | 5% for Tenants
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Save up to 95% compared to traditional brokers
                  </Typography>
                </Paper>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ValueProposition;
